<template>
  <v-layout row wrap>
    <v-col cols :sm="12" class="pa-0">
      <v-card v-show="!Mint.isForm" flat class="pa-2 text-no-wrap">
        <v-data-table
          dense
          must-sort
          fixed-header
          item-key="id"
          :items="Mint.list"
          :options.sync="pagings"
          :headers="cTableHeaders"
          :server-items-length="Mint.total"
          :items-per-page="Mint.filter.limit"
          :footer-props="{ itemsPerPageOptions: Mint.itemPages }"
          :item-class="(e) => (id == e.id ? 'primary lighten-5' : '')"
        >
          <template v-slot:top>
            <v-layout px-2 justify-space-around align-end>
              <v-layout align-center>
                <h2>{{ $t("menu.mint") }}</h2>
                <v-btnc
                  :size="30"
                  icon="mdi-plus"
                  @click="
                    fnCallCreateView(model);
                    _fnLoadData();
                  "
                  v-if="fnCheckMission(Session, [{ m: MINT, p: CREATE }])"
                />
              </v-layout>
              <v-spacer />
              <div class="mb-3" :style="{ width: '250px' }">
                <v-text-field
                  dense
                  single-line
                  hide-details
                  v-model="Mint.search"
                  @keydown.enter="_fnSearch"
                  :placeholder="$t(`table.search`)"
                />
              </div>
            </v-layout>
          </template>
          <template #[`item.createdAt`]="{ item }">
            <v-btnc
              color="warning"
              icon="mdi-pencil"
              @click="
                fnCallUpdateView({ model, item: item });
                _fnLoadData();
              "
              v-if="fnCheckMission(Session, [{ m: MINT, p: UPDATE }])"
            />
            <v-btnc
              color="error"
              icon="mdi-delete"
              @click="fnCallDeleteView({ model, item: item })"
              v-if="fnCheckMission(Session, [{ m: MINT, p: DELETE }])"
            />
          </template>
          <template #[`item.proposer`]="{ item }">
            <span>{{ item.proposer | mAddressFormat(4) }}</span>
          </template>
          <template #[`item.image`]="{ item }">
            <v-upload
              :size="30"
              class="my-1"
              v-model="item.image"
              :readonly="true"
            />
          </template>
          <template #[`item.amount`]="{ item }">
            {{ item.amount | mNumber }}
          </template>
          <template #[`item.type`]="{ item }">
            {{ item.type.name }}
          </template>
          <template #[`item.status`]="{ item }">
            <span
              :class="
                item.status.id == '62b4209a6c7251ee1e094f32'
                  ? 'success--text'
                  : 'warning--text'
              "
            >
              {{ item.status.name }}
            </span>
          </template>
          <template #[`item.updatedBy`]="{ item }">
            {{ item.updatedBy.name }}
          </template>
          <template #[`item.updatedAt`]="{ item }">
            {{ item.updatedAt | mDateTime }}
          </template>
        </v-data-table>
      </v-card>
    </v-col>
    <v-col cols :sm="12" class="pa-0"><v-dialog /></v-col>
  </v-layout>
</template>

<script>
import Dialog from "./dialog.vue";

export default {
  components: {
    "v-dialog": Dialog,
  },
  data() {
    return {
      id: "",
      model: "Mint",
      pagings: {},
    };
  },
  computed: {
    cTableHeaders() {
      let table = [
        {
          text: this.$t(`table.action`),
          sortable: false,
          value: "createdAt",
          width: "10px",
        },
        {
          text: this.$t(`table.address`),
          value: "proposer",
          width: "10px",
        },
        {
          text: this.$t(`table.image`),
          value: "image",
          width: "10px",
        },
        {
          text: this.$t(`table.name`),
          value: "name",
        },
        {
          text: this.$t(`table.amount`),
          value: "amount",
          width: "10px",
        },
        {
          text: this.$t(`table.type`),
          value: "type",
          width: "10px",
        },
        {
          text: this.$t(`table.status`),
          value: "status",
          width: "10px",
        },
        {
          text: this.$t(`table.updatedBy`),
          value: "updatedBy",
          width: "10px",
        },
        {
          text: this.$t(`table.updatedAt`),
          value: "updatedAt",
          width: "10px",
        },
      ];
      return table;
    },
  },
  watch: {
    "Mint.isRefresh": function (val) {
      if (val) {
        this._fnCallListView();
      }
    },
    pagings: function (val) {
      const { itemsPerPage, page, sortBy, sortDesc } = val;
      this[this.model].filter.limit = itemsPerPage;
      this[this.model].filter.page = page;
      if (sortBy.length) {
        this[this.model].filter.sort = `${sortBy[0]}:${sortDesc[0] ? -1 : 1}`;
      }
      this._fnCallListView();
    },
  },
  methods: {
    _fnLoadData() {
      if (this[this.model].isCreate) {
        this[this.model].obj = {
          amount: 0,
          attributes: [],
        };
      } else if (this[this.model].isUpdate) {
        this.id = this[this.model].obj.id;
        this[this.model].obj = {
          ...this[this.model].obj,
          amount: this.fnFormatNumber(this[this.model].obj.amount),
          status: this[this.model].obj.status.id,
          type: this[this.model].obj.type.id,
        };
      }
    },
    _fnCallListView() {
      this.fnCallListView({
        url: "/v1/admin/mint",
        model: this.model,
      });
    },
    _fnSearch({ target: { value } }) {
      if (!value) delete this[this.model].filter.$text;
      else this[this.model].filter.$text = value;
      this._fnCallListView();
    },
  },
};
</script>
